export interface ModeratorState {

}

export enum BanReason {
    FLUD = 'FLUD',
    LANGUAGE = 'LANGUAGE',
    INSULTS = 'INSULTS',
    PROVOCATIONS = 'PROVOCATIONS',
    TRADE = 'TRADE',
    ADVERTISING = 'ADVERTISING',
    FRAUD = 'FRAUD',
    NICKNAME = 'NICKNAME',
    FORBIDDEN_TOPIC = 'FORBIDDEN_TOPIC',
    LAW = 'LAW'
}
